import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import useEntity from './use-entity';
import { getIncludesFromQuery } from '../utils/queries';

function useEntityQuery(query) {
  var _entity$errors;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var args = useMemo(function () {
    var _getIncludesFromQuery;

    return _objectSpread(_objectSpread({}, (query === null || query === void 0 ? void 0 : query.args) || {}), {}, {
      include: query ? ((_getIncludesFromQuery = getIncludesFromQuery(query)) === null || _getIncludesFromQuery === void 0 ? void 0 : _getIncludesFromQuery.join(',')) || undefined : undefined
    });
  }, [query]);
  var entity = useEntity(_objectSpread({
    args: args,
    id: query === null || query === void 0 ? void 0 : query.id,
    model: query === null || query === void 0 ? void 0 : query.model,
    fields: query === null || query === void 0 ? void 0 : query.fields,
    fetch: !!query
  }, options));

  if ((_entity$errors = entity.errors) !== null && _entity$errors !== void 0 && _entity$errors.length && options.throwOnError !== false) {
    throw entity.errors[0].originalError;
  }

  return entity;
}

export default useEntityQuery;